<main>

  <div class="mx-4 mb-10">
    <h3 class="text-4xl font-bold mb-2">Todas Ocorrências</h3>
    <p class="text-sm">Organize e gerencie todas as ocorrências.</p>
  </div>

  <!-- content wrapper -->
  <div class="bg-white p-5 border border-round">

    <!-- filtros aqui -->
    <div class="my-5">
      <app-event-admin-filter (submitFilter)="onFilterSubmit($event)"></app-event-admin-filter>
    </div>
    <app-event-table-list [hideTerminationDate]="true" [events]="events" [hasEvents]="hasEvents"></app-event-table-list>

    @if (pagination) {
      <app-paginator [paginationDetails]="pagination"
                     (pageChangeEvent)="onPageChange($event)"
      ></app-paginator>
    }
  </div>

</main>
